import SearchResult from "./components/SearchResult";
import { useState } from "react";
import SearchContext from "context/SearchContext";
import { SEARCH_PARAMS } from "constants/routes";
import {
  objectToQueryString,
  parseSearchParams,
  useQueryParam,
} from "helpers/search";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { LISTING_CARD_LIMIT } from "constants/layout";
import { Helmet } from "react-helmet";
import { SearchParamsType } from "types/params";
import { LISTING_OUTLET_PARAMS } from "constants/params";
import { BuyerBanners } from "Pages/home/components";
import { useIntl } from "react-intl";

interface ParamTypes {
  categoryId: string;
  countryId?: string;
}

const Category = () => {
  const intl = useIntl();
  const location = useLocation();
  const history = useHistory();
  const { pathname, search } = location;
  const { categoryId, countryId } = useParams<ParamTypes>();
  const searchKeyword = useQueryParam(SEARCH_PARAMS.keyword);
  const pageKeyword = useQueryParam(SEARCH_PARAMS.page);
  const categoryClass = pathname.split("/")[1];
  const isVerifiedParam = useQueryParam(SEARCH_PARAMS.is_verified);
  const countriesParam = useQueryParam(SEARCH_PARAMS.countries);
  const premiumParam = useQueryParam(SEARCH_PARAMS.premium);
  const sortParam = useQueryParam(SEARCH_PARAMS.sort);
  const trustStarParam = useQueryParam("trust_star");

  const [categoryLabel, setCategoryLabel] = useState();

  // Tính toán params khởi tạo từ URL
  const getInitialParams = () => {
    const queryData = parseSearchParams(search, LISTING_OUTLET_PARAMS);
    const { page, ...rest } = queryData;
    return {
      limit: LISTING_CARD_LIMIT.category,
      keyword: searchKeyword,
      category_id: categoryId,
      category_class: categoryClass,
      page: Number(page || pageKeyword || "1"),
      country: countryId,
      filters: {
        is_verified: isVerifiedParam ? Number(isVerifiedParam) : undefined,
        countries: countriesParam ? countriesParam.split(",") : undefined,
        premium: premiumParam ? premiumParam.split(",") : undefined,
        trust_star: trustStarParam ? Number(trustStarParam) : undefined,
      },
      sort: sortParam || "hot",
      ...rest,
    };
  };

  const [params, setParams] = useState<SearchParamsType>(getInitialParams());

  const onUpdateParams = (updateData: any, forceEdited: boolean = false) => {
    const nextData = { ...params, ...updateData };
    
    const queryParams: Record<string, string> = {
      page: String(nextData.page || 1),
    };
    
    if (nextData.keyword) {
      queryParams[SEARCH_PARAMS.keyword] = nextData.keyword;
    }
    
    if (nextData.sort && nextData.sort !== "hot") {
      queryParams[SEARCH_PARAMS.sort] = nextData.sort;
    }
    
    if (nextData.filters) {
      if (nextData.filters.is_verified !== undefined) {
        queryParams[SEARCH_PARAMS.is_verified] = String(nextData.filters.is_verified);
      }
      
      if (nextData.filters.countries && nextData.filters.countries.length > 0) {
        queryParams[SEARCH_PARAMS.countries] = 
          Array.isArray(nextData.filters.countries) 
            ? nextData.filters.countries.join(',') 
            : nextData.filters.countries;
      }
      
      if (nextData.filters.premium && nextData.filters.premium.length > 0) {
        queryParams[SEARCH_PARAMS.premium] = 
          Array.isArray(nextData.filters.premium) 
            ? nextData.filters.premium.join(',') 
            : nextData.filters.premium;
      }
      
      if (nextData.filters.trust_star !== undefined) {
        queryParams["trust_star"] = String(nextData.filters.trust_star);
      }
    }
    
    history.replace({
      search: objectToQueryString(queryParams),
    });
    
    setParams(nextData);
  };

  // BỎ useEffect setParams khi mount để tránh gọi API 2 lần

  return (
    <SearchContext.Provider
      value={{
        params,
        onUpdateParams,
        setCategoryLabel,
        categoryLabel,
        
      }}
    >
      <Helmet>
        {(searchKeyword || pageKeyword) && (
          <meta name="robots" content="noindex, follow" />
        )}
      </Helmet>
      <BuyerBanners positionBanner="header-not-login" isNotRandom={false} />
      <SearchResult />
      <BuyerBanners positionBanner="footer" isNotRandom={false} />
    </SearchContext.Provider>
  );
};

export default Category;
